import type { FontFamily } from "@/lib/api";

export function fontStack(font?: FontFamily | string, category?: string) {
  if (font && typeof font === "object") {
    const cat = font.category || "";
    const fallback =
      cat === "hand"
        ? "cursive, Georgia, serif"
        : cat === "serif" || cat === "display"
          ? "Georgia, serif"
          : "system-ui, sans-serif";
    return `"${font.name}", ${fallback}`;
  }
  const key = String(font || "").toLowerCase();
  const kind = String(category || "").toLowerCase();
  if (kind === "hand" || key.includes("caveat") || key.includes("kalam") || key.includes("dancing") || key.includes("patrick") || key.includes("handlee") || key.includes("shantell")) {
    return '"Caveat", cursive, Georgia, serif';
  }
  if (key.includes("sans") && !key.includes("cormorant")) return '"Source Sans 3", system-ui, sans-serif';
  if (key.includes("lora")) return '"Lora", Georgia, serif';
  if (key.includes("playfair")) return '"Playfair Display", Georgia, serif';
  if (key.includes("fraunces")) return '"Fraunces", Georgia, serif';
  if (key.includes("cormorant")) return '"Cormorant Garamond", Georgia, serif';
  if (kind === "sans") return "system-ui, sans-serif";
  return '"Source Serif 4", Georgia, serif';
}

function faceRule(family: string, url: string | undefined, weight: number, style: "normal" | "italic") {
  if (!url) return "";
  return `@font-face{font-family:"${family}";src:url("${url}") format("truetype");font-weight:${weight};font-style:${style};font-display:swap;}`;
}

export default function FontFaces({ fonts }: { fonts: FontFamily[] }) {
  const css = fonts
    .filter((row) => row.regular_url)
    .map((row) => {
      const name = row.name;
      const regular = faceRule(name, row.regular_url, 400, "normal");
      const bold =
        row.bold_url && row.bold_url !== row.regular_url ? faceRule(name, row.bold_url, 700, "normal") : "";
      const italic =
        row.italic_url && row.italic_url !== row.regular_url
          ? faceRule(name, row.italic_url, 400, "italic")
          : "";
      const boldItalic =
        row.bold_italic_url &&
        row.bold_italic_url !== row.regular_url &&
        row.bold_italic_url !== row.bold_url &&
        row.bold_italic_url !== row.italic_url
          ? faceRule(name, row.bold_italic_url, 700, "italic")
          : "";
      return regular + bold + italic + boldItalic;
    })
    .join("");
  if (!css) return null;
  return <style>{css}</style>;
}
